import { render, staticRenderFns } from "./index.vue?vue&type=template&id=171d7a80&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171d7a80')) {
      api.createRecord('171d7a80', component.options)
    } else {
      api.reload('171d7a80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=171d7a80&", function () {
      api.rerender('171d7a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-user/index.vue"
export default component.exports